// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
/**
 * Represents dictionary with main events.
 */
export const UserEvents = {
    /** On mouse click event (fired on mouse down). */
    onClick: "onClick",
    /** On edit length dimension event (fired on mouse double click); see also [[LengthDimension]]. */
    onEditLengthDimension: "onEditLengthDimension",
    /** On edit text label(fired on mouse double click); see also [[TextLabel]]. */
    onEditTextLabel: "onEditTextLabel",
    /** On command cancel event. */
    onCancel: "onCancel",
    /** On success execution of command event. */
    onSuccess: "onSuccess",
    /** On text input by user. */
    onText: "onText",
    /** On text input request by user. */
    onTextRequest: "onTextRequest",
    /** On user message event. */
    onUserMessage: "onUserMessage",
    /** On displayed objects changed; see also [[InteractiveContext.displayedObjects]]. */
    onDisplayedObjectsChanged: "onDisplayedObjectsChanged",
    /** On selection change; see also [[SelectionManager.selectedObjects]]. */
    onSelectedObjectsChanged: "onSelectedObjectsChanged",
    /** On subview fullscreen mode change. */
    onSubviewFullscreen: "onSubviewFullscreen",
    /** On selection change. */
    onSubviewChanged: "onSubviewChanged",
    /** On animation updated. */
    onAnimationUpdated: "onAnimationUpdated"
};
